import { CameraOutlinedIcon } from '@village/icons';
import { Button } from '@village/ui';
import { FC } from 'react';

import * as Styled from './styles';

interface Props {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const ReasonSwitchModal: FC<Props> = ({ open, onCancel, onConfirm }) => (
    <Styled.Modal open={open} hideCloseButton={true}>
        <Styled.ModalWrapper>
            <Styled.ModalHeaderSection>
                <Styled.IconContainer>
                    <CameraOutlinedIcon customSize={3.25} />
                </Styled.IconContainer>
                <div>
                    <Styled.ModalHeaderTitle type="sub3">You’ve selected a video visit.</Styled.ModalHeaderTitle>
                    <Styled.ModalMessageTitle type="body2">
                        Your provider will send you a link to access the appointment via email or text message shortly before the
                        visit.
                    </Styled.ModalMessageTitle>
                </div>
            </Styled.ModalHeaderSection>
            <Styled.FooterSection>
                <Button variant="link" size="medium" onClick={onCancel}>
                    Cancel
                </Button>
                <Button onClick={onConfirm} size="large">
                    Okay, select video visit
                </Button>
            </Styled.FooterSection>
        </Styled.ModalWrapper>
    </Styled.Modal>
);

export { ReasonSwitchModal };
